<script setup>

import placeholder from "@i/../img/product-placeholder.webp";
import ImgMedia from "@/Components/Images/ImgMedia.vue";
import {computed} from "vue";

const props = defineProps({
    variant: Object,
})

const mainVariant = computed(() => {
    return props.variant.product?.variants?.reduce((prev, current) => (prev.order < current.order) ? prev : current);
});

const media = computed(() => {
    return props.variant.images[0] ?? mainVariant.value?.images[0] ?? props.variant.package?.media[0] ?? null;
});

</script>

<template>
    <ImgMedia
        v-if="media"
        :media="media"
        :sizes="{ '768px': '360px', default: '100vw' }"
        classes="absolute inset-0 h-full w-full object-contain"
    />
    <img
        v-else
        :src="placeholder"
        alt="Product image"
        class="absolute inset-0 size-full object-contain"
        loading="lazy"
    >
</template>
